<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <v-card v-if="word !== null">
      <v-card-title>
        <span class="headline">{{ title }}</span>
        <v-icon
          v-if="type === 'edit'"
          size="28"
          color="red lighten-1"
          @click="deleteWord()"
        >
          mdi-delete-outline
        </v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="word.createdAt"
                label="登録日"
                required
                :error-messages="wordCreatedAtErrors()"
                @input="$v.word.createdAt.$touch()"
                @blur="$v.word.createdAt.$touch()"
              >
                <template v-slot:append-outer>
                  <date-picker v-model="word.createdAt" />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="word.english"
                required
                :error-messages="wordJpnEnErrors('english')"
                @input="$v.word.english.$touch()"
                @blur="$v.word.english.$touch()"
                label="単語の英訳"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="word.japanese"
                required
                :error-messages="wordJpnEnErrors('japanese')"
                @input="$v.word.japanese.$touch()"
                @blur="$v.word.japanese.$touch()"
                label="単語の日訳"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model.number="word.correctCount"
                label="正解数"
                type="number"
                minValue
                integer
                @input="$v.word.correctCount.$touch()"
                @blur="$v.word.correctCount.$touch()"
                :error-messages="wordCountErrors('correct')"
                suffix="回"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.number="word.wrongCount"
                label="不正解数"
                type="number"
                minValue
                integer
                @input="$v.word.wrongCount.$touch()"
                @blur="$v.word.wrongCount.$touch()"
                :error-messages="wordCountErrors('wrong')"
                suffix="回"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select v-model="word.wordType" :items="wordTypes" label="品詞">
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch v-model="word.done" label="完了ステータス"></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeAddDialog">閉じる</v-btn>
        <v-btn color="blue darken-1" text @click="saveClicked">
          {{ buttonTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, minValue, integer } from "vuelidate/lib/validators";
import DatePicker from "./DatePicker";

export default {
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: Boolean,
    },
    type: {
      type: String,
      require: true,
      default: "add", // 'add' or 'edit'
    },
    word: {
      createdAt: "",
      japanese: "",
      english: "",
      correctCount: 0,
      wrongCount: 0,
      done: false,
      wordType: "",
    },
  },
  data: function () {
    return {
      wordTypes: [
        "名詞",
        "代名詞",
        "動詞",
        "形容詞",
        "副詞",
        "前置詞",
        "接続詞",
        "間投詞",
        "熟語",
      ],
    };
  },
  watch: {},
  computed: {
    title() {
      return this.type == "add" ? "単語の追加" : "単語の編集";
    },
    buttonTitle() {
      return this.type == "add" ? "追加" : "編集";
    },
  },
  methods: {
    closeAddDialog() {
      this.$emit("close");
    },
    saveClicked() {
      this.$v.word.$touch();
      if (this.$v.word.$invalid) {
        return;
      }

      if (this.type == "edit") {
        this.$emit("saveClicked", this.word);
      } else {
        this.$emit("addClicked", this.word);
      }

      this.$v.word.$reset();
    },
    deleteWord() {
      this.$emit("deleteWord", this.word);
    },
    wordJpnEnErrors(lang) {
      const errors = [];
      const model = this.type === "add" ? this.$v.word : this.$v.word;
      const target = lang === "english" ? model.english : model.japanese;
      const errorMsg = lang === "english" ? "英訳は必須です" : "日訳は必須です";
      if (!target.$dirty) return errors;
      !target.required && errors.push(errorMsg);
      return errors;
    },
    wordCountErrors(countType) {
      const errors = [];
      const model = self.type === "add" ? this.$v.word : this.$v.word;
      const target =
        countType === "correct" ? model.correctCount : model.wrongCount;

      if (!target.$dirty) return errors;
      !target.required && errors.push("回数は必須です");
      !target.minValue && errors.push("0以上で入力してください");
      !target.integer && errors.push("数値で入力してください");
      return errors;
    },
    wordCreatedAtErrors() {
      const errors = [];
      if (!this.$v.word.createdAt.$dirty) return errors;
      !this.$v.word.createdAt.required && errors.push("日付は必須です");
      return errors;
    },
  },
  validations: {
    word: {
      createdAt: {
        required,
      },
      japanese: {
        required,
      },
      english: {
        required,
      },
      correctCount: {
        minValue: minValue(0),
        required,
        integer,
      },
      wrongCount: {
        minValue: minValue(0),
        required,
        integer,
      },
    },
  },
};
</script>
